<template>
  <router-view />
</template>

<script>
import emitter, { setDeviceStatus } from "@/utils/eventBus";
import { sensors } from "@/utils/userInfo.js";

let socket = null;

export default {
  data() {
    return {
      reconnect: true,
      reconnectAttempts: 0,
      lastSeenTimestamps: {},
      deviceStatuses: {},
    };
  },

  methods: {
  },

  mounted() {
   
     },

  beforeDestroy() {
  }
}
</script>
